import React, { useEffect, useState, useRef } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./regularizationList.css";
import NotFoundData from "../../Images/no-data-found.webp";
import BottomMenu from "../layout/bottomMenu";
import ReactPaginate from "react-paginate";

const RegularizationRequestsForManager = ({
  history,
  match,
  regularizationDetailsForManager,
  regularizationDetails = [],
  getRegularizationRequestFilter,
  regularizationFilter = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [pageNo, setPage] = useState(1)

  useEffect(() => {
    (async () => {
      const listStatus = [0];
      setIsLoading(true);
      await regularizationDetailsForManager(1, listStatus);
      await getRegularizationRequestFilter();
      setIsLoading(false);
    })();
  }, [regularizationDetailsForManager]);

  const handleSubmitFilter = async () => {
    const listStatus = [0];
    localStorage.setItem(
      "regularization_filters",
      JSON.stringify(filterInputList)
    );
    setOpen(false);
    setIsLoading(true);
    await regularizationDetailsForManager(
      pageNo,
      listStatus,
      null,
      null,
      filterInputList
    );
    setIsLoading(false);
  };

  const handleFilter = async (key, value) => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const handleRemoveFilter = async (key) => {
    const listStatus = [0];
    if (key !== "") {
      if (filterInputList === undefined || filterInputList === null) {
        delete window.localStorage.regularization_filters;
      }
      delete filterInputList[0][key];
      setFilterInputList(filterInputList);
      setIsLoading(true);
      await regularizationDetailsForManager(
        pageNo,
        listStatus,
        null,
        null,
        filterInputList
      );
      setIsLoading(false);
    }
  };

  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const onPageChange = async (val) => {
    setPage(val?.selected+1)
    const listStatus = [0];
    localStorage.setItem(
      "regularization_filters",
      JSON.stringify(filterInputList)
    );
    setIsLoading(true)
    await regularizationDetailsForManager(
      val?.selected+1,
      listStatus,
      null,
      null,
      filterInputList
    );
    setIsLoading(false)
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Request List"} history={history} />
            <div className="container-fluid common-bg">
              {/* Heading */}
              <div className="container-fluid bootstrap snippets bg-white">
                <div className="d-sm-flex align-items-center justify-content-between mb-2">
                  <div className="row col-md-12">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                      {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                    </div>
                    <div className="col-md-6 cs-pos">
                      <button
                        onClick={() => setOpen(!open)}
                        className="btn btn-sm btn-primary mr-1 btn-filter"
                        type="button"
                      >
                        <i className="fa fa-filter lh-35 pd-3"></i>
                      </button>
                    </div>
                  </div>
                </div>
                {filterInputList[0] !== undefined &&
                  Object.keys(filterInputList[0]).length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mt-4 mr-4 overflow-auto">
                      <div className="row pd-filter-div">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterInputList[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterInputList[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                      onClick={(e) => {
                                        handleRemoveFilter(val);
                                      }}
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                <div className="attendance-record mt-4">
                  {regularizationDetails?.data?.data?.map((record, index) => (
                    <div className="attendance-item" key={index}>
                      <div className="right-side">
                        <div>
                          <b>Requester Name:</b> {record?.requester_name}
                        </div>
                        <div>
                          <b>Requester Email:</b> {record?.requester_email}
                        </div>
                        {record?.regularization_type && record?.regularization_type == 'WOOO' ? (
                          <div>
                            <b>Type of Request:</b> {'Work out of office'}
                          </div>
                          ):(
                          <div>
                            <b>Type of Request:</b> {record?.regularization_type}
                          </div>
                        )}
                        {/* <div className="date-container">
                          <div>
                            <b>Date:</b> {record?.regularization_date}
                          </div>
                          <a
                            href={`regularization-approve-reject/${record?.id}/${record?.regularization_type}`}
                            className="view-details-button"
                          >
                          </a>
                        </div> */}

                      {record?.regularization_type && record?.regularization_type == 'WOOO' ? (
                        <div className="date-container">
                          <div>
                            <b>Date:</b> {record?.regularization_date}
                          </div>
                          <a
                            href={`regularization-approve-reject/${record?.id}/${record?.regularization_type}`}
                            className="btn-btn-primary"
                          >
                            <i className="bi bi-eye-fill"></i>
                          </a>
                        </div>
                      ) : (
                      <>
                        <div className="date-container">
                          <div>
                            <b>Requested Date:</b> {formatDate(record?.regularization_date)}
                          </div>
                        </div>
                        <div className="date-container">
                          <div>
                            <b>Regularization Date:</b> {formatDate(record?.regularization_date)}
                          </div>
                          <a
                            href={`regularization-approve-reject/${record?.id}/${record?.regularization_type}`}
                            className="btn-btn-primary"
                          >
                            <i className="bi bi-eye-fill"></i>
                          </a>
                        </div>
                      </>
                      )}

                      </div>
                    </div>
                  ))}
                  {console.log("PER PAGE CHECK: ", regularizationDetails?.data)}

                  
                  {regularizationDetails && regularizationDetails?.data && regularizationDetails?.data?.data && regularizationDetails?.data?.data?.length > 0 && (
                    <div className="panel-pagination-col panel-table-pagination mt-5">
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={(regularizationDetails?.data?.total /regularizationDetails?.data?.per_page)}
                            forcePage={regularizationDetails?.data?.current_page - 1}
                            pageRangeDisplayed={4}
                            onPageChange={onPageChange}
                            activeClassName={'active'}
                        />
                    </div>
                  )}

                  {/* {console.log("REGULARIZATION DETAILS: ", regularizationDetails?.data)} */}

                  {regularizationDetails &&
                    regularizationDetails?.data &&
                    regularizationDetails?.data?.data &&
                    regularizationDetails?.data?.data?.length === 0 && (
                      <div className="text-center">
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={"not found"}
                        />
                        <br />
                        <div style={{ fontSize: "large", fontWeight: "400" }}>
                          No data found
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BottomMenu
          open={open}
          setOpen={setOpen}
          filterContent={regularizationFilter}
          handleFilter={handleFilter}
          handleSubmitFilter={handleSubmitFilter}
          localstorageKeyRemove={"regularization_filters"}
        />
      </div>
    </>
  );
};

export default RegularizationRequestsForManager;
